import { bankServices } from "../../config/axios";
import {
    BANK_ROLELIST_SUCCESS,
    BANK_ROLELIST_FAILED,
    RESET_BANK_ROLELIST,
    LOADING_BANK_ROLELIST,
    BANK_ROLELIST_NETWORKERROR,
} from '../types/index';

const resetbankRoleList = () => {
    return { type: RESET_BANK_ROLELIST };
};

const bankRoleList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANK_ROLELIST });
    await bankServices
        .post("rolelist", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BANK_ROLELIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BANK_ROLELIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BANK_ROLELIST_FAILED,
        payload: data
    };
}

export { resetbankRoleList, bankRoleList }